import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SystemLabel from '../../../system/SystemLabel/SystemLabel';
import { cmsActions } from '../../../store/actions/cms/cms.action';
import { sourceTypes } from '../../../constants/cms/sourceType';
import { formActions } from '../../../store/actions/cms/form/form.action';
import { templateActions } from '../../../store/actions/cms/template/template.action';
import { pageActions } from '../../../store/actions/cms/page/page.action';

const MergeAlerter = (props) => {
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);
    const { dispatch, form, page, cms, template, type } = props;
    const { mergeSource, showMergeAlert, mergeCallback } = cms;

    if (showMergeAlert) {
        return <div>
            <Modal isOpen={showMergeAlert} toggle={toggle} >
                <ModalHeader toggle={toggle}><SystemLabel name="MergeConflict" /></ModalHeader>
                <ModalFooter>
                    <Button color="warning" onClick={() => {

                        dispatch(cmsActions.alertNewModifications(false))

                        switch (mergeSource[0]) {
                            case sourceTypes.FORM:
                                dispatch(formActions.checkForUpdates(form, true))
                                break;
                            case sourceTypes.PAGE:
                                dispatch(pageActions.checkForUpdates(page, true))
                                break;
                            case sourceTypes.TEMPLATE:
                                dispatch(templateActions.checkForUpdates(template, true))
                                break;
                            default:
                                break;
                        }
                    }}><SystemLabel name="OverWrite" /></Button>{' '}
                    <Button color="default" onClick={() => {
                        toggle();
                        props.dispatch(cmsActions.alertNewModifications(false))
                    }}><SystemLabel name="Cancel" /></Button>
                </ModalFooter>
            </Modal>
        </div>
    }
    else {
        return null;
    }

}


function mapStateToProps(state) {
    return {
        cms: state.cms,
        form: state.form,
        template: state.template.template,
        page: state.page
    };
}


export default connect(mapStateToProps)(MergeAlerter);
